import { ChartCategory, ChartCategoryFormat, HorizontalScroll } from '@va/ui/design-system';
import LineChartCategoriesSkeletonPlaceholder from './LineChartCategoriesSkeletonPlaceholder';

export type LineChartCategoriesProps = {
  items: Array<{
    valueDetails?: string;
    label: string;
    color: string;
    value: number;
    percentage: number;
    format?: ChartCategoryFormat;
    id: string;
  }>;
  selectedItems: Array<string>;
  onClick: (identifier: string) => void;
  format?: ChartCategoryFormat;
  reversePercentageColors?: boolean;
  isLoading?: boolean;
};

/** @deprecated use ChartTiles instead */
export const LineChartCategories = ({
  items,
  selectedItems,
  onClick,
  format,
  reversePercentageColors = false,
  isLoading = false,
}: LineChartCategoriesProps) => {
  if (isLoading) return <LineChartCategoriesSkeletonPlaceholder totalItems={items.length !== 0 ? items.length : 5} />;

  return (
    <HorizontalScroll>
      <div className='flex'>
        {items.map((item) => {
          const selected =
            selectedItems.find((selectedItem) => {
              return selectedItem === item.id;
            }) !== undefined;

          return (
            <ChartCategory
              key={item.id}
              label={item.label}
              value={item.value}
              valueDetails={item?.valueDetails}
              color={item.color}
              percentage={item.percentage}
              selected={selected}
              onClick={() => {
                onClick(item.id);
              }}
              format={format || item.format || 'number'}
              reversePercentageColors={reversePercentageColors}
            />
          );
        })}
      </div>
    </HorizontalScroll>
  );
};
